import { globalColor } from '../utils/globals';
import React, { useState } from 'react';
import styled from 'styled-components';

interface ToggleSwitchProps {
    id?: string; // Optional ID for the toggle switch
    isOn?: boolean;
    onToggle?: (state: boolean, id?: string) => void;
}
const ToggleContainer = styled.div<{ isOn: boolean; backgroundColor?: string }>`
    width: 30px; // reduced from 45px
    height: 18px; // reduced from 20px
    border-radius: 10px;
    background-color: ${({ isOn, backgroundColor }) =>
        isOn ? backgroundColor || '#4caf50' : '#ccc'};
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
`;

const ToggleKnob = styled.div<{ isOn: boolean }>`
    width: 12px; // reduced from 20px
    height: 12px; // reduced from 20px
    border-radius: 50%;
    margin-left: ${({ isOn }) => (isOn ? '0px' : '4px')};
    background-color: white;
    transform: ${({ isOn }) =>
        isOn ? 'translateX(14px)' : 'translateX(0)'}; // adjusted translation
    transition: transform 0.3s ease;
`;
const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
    id,
    isOn = false,
    onToggle,
}) => {
    const [toggleState, setToggleState] = useState(isOn);

    React.useEffect(() => {
        setToggleState(isOn);
    }, [isOn]);

    const handleToggle = () => {
        const newState = !toggleState;
        setToggleState(newState);
        if (onToggle) {
            onToggle(newState, id);
        }
    };

    return (
        <ToggleContainer
            isOn={toggleState}
            backgroundColor={globalColor.backgroundColor2}
            onClick={handleToggle}
        >
            <ToggleKnob isOn={toggleState} />
        </ToggleContainer>
    );
};

export default ToggleSwitch;